import C_PointerEvt from "../const/C_PointerEvt";
import C_Snd from "../../const/C_Snd";

/**
 * Basic button with changeable skins based on state
 */
class Button extends PIXI.Sprite
{


    constructor(skin, skinOver, skinDown, skinDisabled)
    {
        super(PIXI.app.assets.getTexture(skin));

        skinOver = skinOver == undefined ? skin : skinOver;
        skinDown = skinDown == undefined ? skin : skinDown;
        skinDisabled = skinDisabled == undefined ? skin : skinDisabled;

        this.skin = skin;
        this.skinOver = skinOver;
        this.skinDown = skinDown;
        this.skinDisabled = skinDisabled;

        this.app = PIXI.app;
        this.assets = this.app.assets;
        this.interactive = true;
        this.down = false;
        this.over = false;

        this.on('removed', this.destroy, this);
        this.on('pointerover', this.onMouseOver, this);
        this.on(C_PointerEvt.ROLLOUT, this.onMouseOut, this);
        this.on(C_PointerEvt.DOWN, this.onMouseDown, this);
        this.on(C_PointerEvt.UP, this.onMouseUp, this);

        this.downSndId = C_Snd.BTN_DOWN;
    }


    onMouseOver()
    {
        if (this.interactive)
        {
            this.texture = this.assets.getTexture(this.skinOver);
        }
        this.over = true;
    }


    onMouseOut()
    {
        if (this.interactive)
        {
            this.texture = this.assets.getTexture(this.skin);
        }
        this.over = false;
    }


    onMouseDown()
    {
        if (this.interactive)
        {
            this.app.sound.playSound(this.downSndId);
            this.texture = this.assets.getTexture(this.skinDown);
            this.down = true;
        }
    }


    onMouseUp()
    {
        if (this.interactive)
        {
            this.texture = this.assets.getTexture(this.over ? this.skinOver : this.skin);
            this.down = false;
        }
    }


    setEnabled(enabled)
    {
        this.interactive = enabled;

        if (enabled)
        {
            this.texture = this.assets.getTexture(this.over ? this.skinOver : this.skin);
        }
        else
        {
            this.over = false;
            this.texture = this.assets.getTexture(this.skinDisabled);
        }
    }


    setSkins(skin, skinOver, skinDown, skinDisabled)
    {
        this.skin = skin;
        this.skinOver = skinOver;
        this.skinDown = skinDown;
        this.skinDisabled = skinDisabled;

        if (this.interactive)
        {
            if (this.down)
            {
                this.texture = this.app.assets.getTexture(skinDown);
            }
            else if (this.over)
            {
                this.texture = this.app.assets.getTexture(skinOver);
            }
            else
            {
                this.texture = this.app.assets.getTexture(skin);
            }
        }
        else
        {
            this.texture = this.app.assets.getTexture(skinDisabled);
        }

    }


    destroy()
    {
        this.removeChildren();
        this.removeAllListeners();

        // todo - for some reason this causes a crash
        super.destroy();
    }


}

export default Button